module.exports = __webpack_public_path__ + "img/everyBody_0428.9919c306.png";